import { render, staticRenderFns } from "./DocumentLimitTransactionSign.vue?vue&type=template&id=140e8e0a&scoped=true&"
import script from "./DocumentLimitTransactionSign.vue?vue&type=script&lang=js&"
export * from "./DocumentLimitTransactionSign.vue?vue&type=script&lang=js&"
import style0 from "./DocumentLimitTransactionSign.vue?vue&type=style&index=0&id=140e8e0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140e8e0a",
  null
  
)

export default component.exports